// extracted by mini-css-extract-plugin
export default {"jsaTabContainer":"SafetyAuditJsaTab_jsaTabContainer__SGHi4","jsaLoading":"SafetyAuditJsaTab_jsaLoading__gJgP0","noJsa":"SafetyAuditJsaTab_noJsa__Jpv3m"};